import { render, staticRenderFns } from "./EnsembleCard.vue?vue&type=template&id=1b527a4e"
import script from "./EnsembleCard.vue?vue&type=script&lang=js"
export * from "./EnsembleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b527a4e')) {
      api.createRecord('1b527a4e', component.options)
    } else {
      api.reload('1b527a4e', component.options)
    }
    module.hot.accept("./EnsembleCard.vue?vue&type=template&id=1b527a4e", function () {
      api.rerender('1b527a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/EnsembleCard.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EnsembleCard.vue
// module id = 384
// module chunks = 0